var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.src)?_c('div',{ref:"wrap",staticClass:"apng-div",style:({width:_vm.width,height:_vm.height})},[_c('canvas',{ref:"apng-canvas"})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }